import { Routes } from 'react-router-dom';
import { publicRoutes } from './public/routes';
import { restaurantRoutes, restaurantPanelRoutes } from './restaurant/routes';
import { adminRoutes } from './admin/routes';

const AppRoutes = () => (
  <Routes>
    {publicRoutes}
    {restaurantRoutes}
    {restaurantPanelRoutes}
    {adminRoutes}
  </Routes>
);

export default AppRoutes;
